import { render } from "./LoadingSelect.vue?vue&type=template&id=3168fe1e"
import script from "./LoadingSelect.vue?vue&type=script&lang=js"
export * from "./LoadingSelect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__